class LoadMoreSingle {
  constructor() {
    this.ajaxUrl = siteConfig?.ajaxUrl ?? '';
    this.ajaxNonce = siteConfig?.ajax_nonce ?? '';
    this.loadMoreBtn = document.querySelector('#single-post-load-more-btn');
    this.loadingTextEl = document.querySelector('#single-loading-text');
    this.isRequestProcessing = false;
    this.logger = window.Logger ? window.Logger.create('LoadMoreSingle') : null;

    this.init();
  }

  init() {
    if (!this.loadMoreBtn) {
      return;
    }

    const maxPagesRaw = this.loadMoreBtn.dataset?.maxPages;
    this.totalPagesCount = maxPagesRaw ? Number.parseInt(maxPagesRaw, 10) : 0;

    this.loadMoreBtn.addEventListener('click', () => {
      this.handleLoadMorePosts();
    });
  }

    /**
     * Load more posts.
     *
     * 1.Make an ajax request, by incrementing the page no. by one on each request.
     * 2.Append new/more posts to the existing content.
     * 3.If it's the last page, remove the load-more button from DOM.
     *
     * @return null
     */
  async handleLoadMorePosts() {
    // Get page no from data attribute of load-more button.
    const pageRaw = this.loadMoreBtn?.dataset?.page;
    const singlePostId = this.loadMoreBtn?.dataset?.singlePostId ?? '';

    // Preserve prior guard: only bail if page is undefined/invalid, plus in-flight guard.
    if (pageRaw === undefined || this.isRequestProcessing) {
      return null;
    }

    const page = Number.parseInt(pageRaw, 10);
    if (!Number.isFinite(page)) {
      return null;
    }

    const nextPage = page + 1; // Increment page count by one.

    this.toggleLoading(true);

    try {
      const response = await fetch(this.ajaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new URLSearchParams({
          page: String(page),
          single_post_id: String(singlePostId),
          action: 'single_load_more',
          ajax_nonce: this.ajaxNonce || '',
        }),
      });

      if (!response.ok) {
        throw response;
      }

      const responseText = await response.text();
      if (this.loadMoreBtn) {
        this.loadMoreBtn.dataset.page = String(nextPage);
      }

      const contentEl = document.querySelector('#single-post-load-more-content');
      if (contentEl) {
        contentEl.insertAdjacentHTML('beforeend', responseText);
      }

      this.removeLoadMoreIfOnLastPage(nextPage);
    } catch (response) {
      if (this.logger) {
        this.logger.error('Failed to load more single posts', {response, page, singlePostId});
      } else {
        console.log(response);
      }
    } finally {
      this.toggleLoading(false);
    }
  }

    /**
     * Remove Load more Button If on last page.
     *
     * @param {int} nextPage New Page.
     */
  removeLoadMoreIfOnLastPage(nextPage) {
    if (nextPage + 1 > this.totalPagesCount) {
      this.loadMoreBtn?.remove();
    }
  }

    /**
     * Toggle Loading
     *
     * Show or hide the loading text.
     *
     * @param isLoading
     */
  toggleLoading(isLoading) {
    this.isRequestProcessing = isLoading;

    if (!this.loadingTextEl) {
      return;
    }

    if (isLoading) {
      this.loadingTextEl.classList.add('block');
      this.loadingTextEl.classList.remove('hidden');
    } else {
      this.loadingTextEl.classList.add('hidden');
      this.loadingTextEl.classList.remove('block');
    }
  }
}

new LoadMoreSingle();
